import axios from "axios";
class CaptchaService {
    static verifyCaptcha = async (captchaToken) => {
        const response = await axios.get("/captcha", { params: { captchaToken } });
        return response.data;
    };
}
export default CaptchaService;
